import React from 'react';
import PropTypes from 'prop-types';
import { compose, withStateHandlers, pure } from 'recompose';
import { reduxForm } from 'redux-form/immutable';
import { pick } from 'lodash';
import classNames from 'classnames';

import { withPatch } from '../../../entities/Entity/containers';
import * as NotificationActions from '../../../components/Notifications/actions';
import { ButtonSmall } from '../../../components/Button/index';
import requireProps from '../../../lib/requireProps';
import * as styles from '../styles.css';
import InfoToolTip from '../../InfoToolTip';
import { useTranslation } from 'react-i18next';

function TinyForm({
  renderField,
  isEditable,
  open,
  handleSubmit,
  isBlock,
  tooltip,
  className,
  initialValues,
}) {
  const { t } = useTranslation();
  return (
    <div className={classNames(
      {
        [styles.tinyForm]: !isEditable,
        [styles.inline]: !isBlock,
        [className]: !!className && !isEditable,
      })}
    >
      {!isEditable && (
        <ButtonSmall
          onClick={open}
          icon="pencil-square-o"
          className={classNames(
            styles.editBtn,
            { [styles.block]: isBlock },
          )}
        />
      )}
      {renderField({ isEditable, initialValues })}
      {isEditable && (
        <div>
          <ButtonSmall onClick={handleSubmit} icon="cloud" variant="primary">{t("Spara")}</ButtonSmall>
          <InfoToolTip title={tooltip.title}>
            {tooltip.body}
          </InfoToolTip>
        </div>
      )}
    </div>
  );

}

TinyForm.defaultProps = {
  isBlock: false,
  tooltip: {
    title: 'Uppdatering av värde',
    body: 'Observera att denna kommer uppdatera värdet på konsulten.',
  },
  className: undefined,
};

TinyForm.propTypes = {
  renderField: PropTypes.func.isRequired,
  open: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isEditable: PropTypes.bool.isRequired,
  isBlock: PropTypes.bool,
  tooltip: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
  }),
  className: PropTypes.string,
};

export default compose(
  pure,
  requireProps(['patchUrl']),
  withStateHandlers({ isEditable: false }, {
    open: () => () => ({ isEditable: true }),
    close: () => () => ({ isEditable: false }),
  }),
  withPatch({
    props: ({ patch, patchUrl, hiddenPatchUrls, close, path, message, updateValue, ...props }) => ({
      ...props,
      isLoading: props.fetchLoading || props.isLoading,
      patch: (values, dispatch) => {
        const entity = pick(values.toJS(), path);
        patch({
          url: patchUrl,
          entity,
        })
          .then(() => {
            close();
            if (updateValue) {
              updateValue(pick(values.toJS(), path)[path]);
            }
            dispatch(NotificationActions.addSuccess({ message }));
          });

        if (hiddenPatchUrls) {
          hiddenPatchUrls.forEach((url) => {
            patch({ url, entity });
          });
        }
      },
    }),
  }),
  reduxForm({
    onSubmit: (values, dispatch, formProps) => formProps.patch(values, dispatch),
    enableReinitialize: true,
    pure: true,
  }),
)(TinyForm);
